// extracted by mini-css-extract-plugin
module.exports = {"remove":"Cart_remove__vT-ZQ","inner":"Cart_inner__1gCne","paymentOpt":"Cart_paymentOpt__2gw4C","paymentContainer":"Cart_paymentContainer__2nrIt","paypalArea":"Cart_paypalArea__19HzA","stripeBtn":"Cart_stripeBtn__2ExeM"};
    if(module.hot) {
      // 1686459232439
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  